import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=3c5df5a1&scoped=true&"
import script from "./UIButton.vue?vue&type=script&lang=js&"
export * from "./UIButton.vue?vue&type=script&lang=js&"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=3c5df5a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5df5a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5df5a1')) {
      api.createRecord('3c5df5a1', component.options)
    } else {
      api.reload('3c5df5a1', component.options)
    }
    module.hot.accept("./UIButton.vue?vue&type=template&id=3c5df5a1&scoped=true&", function () {
      api.rerender('3c5df5a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UIButton.vue"
export default component.exports